import {Component, OnInit} from '@angular/core';
import { DialogRef } from "@fundamental-ngx/core/dialog";
import {Utils} from "../../../../core/helpers/Utils";
import {NotificationsService} from "../../../../service/services/misc/notifications/notifications.service";

@Component({
    selector: 'app-move-resource-status-dialog',
    templateUrl: './move-resource-status-dialog.component.html',
    styleUrls: ['./move-resource-status-dialog.component.scss'],
    standalone: false
})
export class MoveResourceStatueDialogComponent implements OnInit {
    operationId: string;
    message: string;
    state: string;
    errorsMap: Map<string, string> = new Map<string, string>();

    constructor(
        public dialogRef: DialogRef,
        private notificationsService: NotificationsService,
    ) {}

    ngOnInit(): void {
        this.operationId = this.dialogRef?.data?.operationId;
        this.message = this.dialogRef?.data?.status?.message;
        this.state = this.dialogRef?.data?.status?.state;
        const errors = this.dialogRef?.data?.status?.errors;
        if (errors) {
            for (const error of errors) {
                this.errorsMap.set(error.controller, error.message);
            }
        }
    }

    onCopyOperationId() {
        this.notificationsService.showMessageToast($localize`:XMSG|Toast for copying operation id@@general.copyOperationIdToast:Operation id copied to your clipboard`);
        Utils.copyToClipboard(this.operationId);
    }

    onClose() {
        this.dialogRef.close();
    }
}
